import { CustomTable, InputSearchField, UserAvatarWithName } from 'components'
import { GetBlockedCreatorsList, GetCreatorsList, useDebounce } from 'hooks'
import React, { useEffect, useMemo, useState } from 'react'
import { CommonUtility, UsersService } from 'utility'
import { ActionBox } from 'components/ActionBox'

const CommonColumn = [
    {
        title: 'Creator Name',
        dataIndex: 'name',
        key: 'name',
        width: 200,
        render: (_, record) => (
            <UserAvatarWithName id={record?.firebase_uid} title={record.name} url={record.photo_url} />
        ),
    },

    {
        title: 'Genre',
        dataIndex: 'genre',
        key: 'genre',
    },
    {
        title: 'Followers',
        dataIndex: 'followers',
        key: 'followers',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
    },
    {
        title: 'Birth Date',
        dataIndex: 'birth_date',
        key: 'birth_date',
    },
    {
        title: ' Videos',
        dataIndex: 'videos',
        key: 'videos',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
    },
]
export const AllCreatorsScreen = () => {
    const { data: CreatorData, filter, pageChanged, pageSizeChanged, total, loading, updateFilter } = GetCreatorsList()
    const [data, setData] = useState([])
    const [search, setSearch] = useState()
    const finalSearch = useDebounce(search, 1000)

    useEffect(() => {
        if (finalSearch?.trim() || finalSearch?.trim() === '') {
            updateFilter('search', finalSearch?.trim())
        }
    }, [finalSearch])

    useEffect(() => {
        setData(CreatorData)
    }, [CreatorData])

    const onDelete = async record => {
        await UsersService.deleteUser(record.firebase_uid, false)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const onBlock = async record => {
        await UsersService.block(record.firebase_uid, !record.isBlocked)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const columns = useMemo(
        () => [
            ...CommonColumn,
            {
                title: 'Action',
                dataIndex: 'Action',
                key: 'Action',
                render: (_, record) => (
                    <ActionBox
                        item={record}
                        onBlock={() => onBlock(record, !record.isBlocked)}
                    />
                ),
            },
            {
                title: 'Action',
                dataIndex: 'Action',
                key: 'Action',
                align: 'right',
                width: 100,
                render: (_, record) => (
                    <div className="d-flex">
                        <ActionBox item={record} onDelete={() => onDelete(record)} />
                    </div>
                ),
            },
        ],
        [data],
    )

    return (
        <div>
            <div className="px-5">
                <div className="d-flex justify-content-end">
                    <InputSearchField
                        placeholder="Search here..."
                        onChange={val => setSearch(val)}
                        className="w-25"
                    />
                </div>
                <CustomTable
                    data={data}
                    columns={columns}
                    pageChanged={pageChanged}
                    updateFilter={updateFilter}
                    pageSizeChanged={pageSizeChanged}
                    page={filter.page}
                    pageSize={filter.limit}
                    loading={loading}
                    total={total}
                />
            </div>
        </div>
    )
}

export const BlockedCreatorsScreen = () => {
    const { data: CreatorData, filter, pageChanged, pageSizeChanged, total, loading, updateFilter } = GetBlockedCreatorsList()
    const [data, setData] = useState([])
    const [search, setSearch] = useState()
    const finalSearch = useDebounce(search, 1000)

    useEffect(() => {
        if (finalSearch?.trim() || finalSearch?.trim() === '') {
            updateFilter('search', finalSearch?.trim())
        }
    }, [finalSearch])

    useEffect(() => {
        setData(CreatorData)
    }, [CreatorData])

    const onDelete = async record => {
        await UsersService.deleteUser(record.firebase_uid, false)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const onBlock = async record => {
        await UsersService.block(record.firebase_uid, !record.isBlocked)
        setData(data.filter(ele => ele.firebase_uid !== record.firebase_uid))
    }

    const columns = useMemo(
        () => [
            ...CommonColumn,
            {
                title: 'Action',
                dataIndex: 'Action',
                key: 'Action',
                render: (_, record) => (
                    <ActionBox
                        item={record}
                        onBlock={() => onBlock(record, !record.isBlocked)}
                    />
                ),
            },
            {
                title: 'Action',
                dataIndex: 'Action',
                key: 'Action',
                align: 'right',
                width: 100,
                render: (_, record) => (
                    <div className="d-flex">
                        <ActionBox item={record} onDelete={() => onDelete(record)} />
                    </div>
                ),
            },
        ],
        [data],
    )

    return (
        <div>
            <div className="px-5">
                <div className="d-flex justify-content-end">
                    <InputSearchField
                        placeholder="Search here..."
                        onChange={val => setSearch(val)}
                        className="w-25"
                    />
                </div>
                <CustomTable
                    data={data}
                    columns={columns}
                    pageChanged={pageChanged}
                    updateFilter={updateFilter}
                    pageSizeChanged={pageSizeChanged}
                    page={filter.page}
                    pageSize={filter.limit}
                    loading={loading}
                    total={total}
                />
            </div>
        </div>
    )
}